import { Component, OnInit, ViewChild } from '@angular/core';
import { Brand } from '../../shared/models/brand';
import { BrandService } from '../../shared/services/brand.service';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
//import { MatPaginatorModule } from '@angular/material/paginator'; 
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { SpinnerService } from '../../shared/components/spinner/spinner.service';

declare var $: any;

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ["./brands.component.css"]
})

export class BrandsComponent implements OnInit {
  public brands: Brand[];

  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<Brand>();
  displayedColumns: string[] = ['name', 'templateId', 'brandId', 'brandsCount', 'locationsNo', 'startDate'];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private brandService: BrandService, private router: Router, private spinnerService: SpinnerService) { }

  ngOnInit() {
    // show spinner on page load
    this.spinnerService.show();
     
    // hide spinner
    setTimeout(() => {
      this.getBrands(false);
      this.spinnerService.hide();
    }, 1500); 
  }

  getBrands(showInactive: boolean) {
    // get all master brands 
    if (showInactive) {
      this.brandService.getInactiveBrands().subscribe(result => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 
          this.dataSource.data = result;

        }, error => console.error(error));
    }
    else {
      this.brandService.getActiveBrands().subscribe(result => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 
          this.dataSource.data = result;
        }, error => console.error(error));
      }  
  }

  add(name: string): void {
    name = name.trim();
    if (!name) { return; }
    this.brandService.add({name : name } as Brand)
      .subscribe(brand => { 
        this.hideAddBrandModal();
        this.router.navigate(['/brand/'+ brand.id]); 
      });
  } 

  // hide modal
  hideAddBrandModal(): void {
    $("#addBrandModal").modal('hide');
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  showInactive(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).checked;

    this.getBrands(filterValue);
   } 
}

